import Label from "../Label";
import { Control, Controller } from "react-hook-form";
import FileUpload from "./FileUpload";

export default function FileUploadField({
  control,
  name,
  label,
  options,
  hint,
  disabled = false,
}: {
  name: string;
  label?: string;
  control?: Control<any>;
  options?: {
    isImage?: boolean;
    multiple?: boolean;
    selectExisting?: boolean;
    storageDirectory?: "images" | "assets" | "files";
    maxFiles?: number;
    sortable?: boolean;
    accept?: string;
  };
  hint?: string;
  disabled?: boolean;
}) {
  // Default to "images" storage directory when isImage is true
  const storageDirectory =
    options?.storageDirectory ?? (options?.isImage ? "images" : undefined);
  const finalOptions = { ...options, storageDirectory };

  return (
    <div className="control-group">
      {label && <Label label={label} />}
      <div className="controls">
        <Controller
          name={name}
          control={control}
          render={({ field }) => (
            <FileUpload field={field} {...finalOptions} disabled={disabled} />
          )}
        />
        {hint && <span className="text-muted text-sm">{hint}</span>}
      </div>
    </div>
  );
}
